import Hero from "../components/Hero";
import Manifesto from "../components/Manifesto";
import FinalCTA from "../components/FinalCTA";

export default function Home() {
  return (
    <>
      
      <Hero />
      <Manifesto />
      <FinalCTA />
    </>
  );
}


